import React from 'react';
import { createComponent } from '@lit/react';
import { IxTextbox as LitComp } from '../IxTextbox.js';

customElements.define('ix-textbox', LitComp);

export const IxTextbox = createComponent({
  tagName: 'ix-textbox-react',
  elementClass: LitComp,
  react: React,
});
